import React from 'react';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/MicroBundle/addNewMicroBundleStyle';
import Button from 'components/CustomButtons/Button';
import { BodyS, BodySBold } from 'components/Typography/Typography';

interface IWebHostingBody {
	data: string;
	buttonText?: string;
	onContinueClick?: () => void;
	heading?: string;
}

//@ts-ignore
const useStyles = makeStyles(styles);

const ServiceInfo = (props: IWebHostingBody) => {
	let classes = useStyles();
	let valueObj = {};
	if (props.data) {
		valueObj = JSON.parse(props.data);
	}
	const keys = Object.keys(valueObj);
	return (
		<div className={classes.serviceInfoComponentWrapper}>
			{keys.length > 0 &&
				keys.map((key, index) => {
					return (
						<div key={index} className={classes.serviceInfoContent}>
							<BodySBold
								changeFontSize={false}
								customClassName={classes.serviceInfoKey}
							>{`${key}:`}</BodySBold>
							<BodySBold changeFontSize={false} customClassName={classes.serviceInfo}>
								{valueObj[key]}
							</BodySBold>
						</div>
					);
				})}
			{props.buttonText && (
				<Button color={'primary-light'} className={classes.serviceInfoFooter} onClick={props.onContinueClick}>
					{props.buttonText}
				</Button>
			)}
		</div>
	);
};

export default ServiceInfo;
